import { createAction } from '@reduxjs/toolkit';
import type { AppState } from '@src/providers/AppStateProvider/types';
import type { MarketSecurityStatus } from '@talos/kyoko';
import { getRFQMarketSelectorItems } from '../../MarketSelector/RFQ/getRFQMarketSelectorItems';
import type { MarketSelectorItem, MarketSelectorValue } from '../../MarketSelector/types';
import { getInitMarketsThunk } from '../Common/marketSelectionSliceUtils';
import { rfqSelectors } from './selectors';

export const initializeRFQMarketsField = createAction<{
  desiredValue: MarketSelectorValue | undefined;
  items: MarketSelectorItem[];
  defaultToEmptyMarkets?: boolean;
  allowDisabledSelections?: boolean;
}>('RFQ/initializeRFQMarketsField');

export const initializeRFQMarketsFieldThunk = getInitMarketsThunk({
  sliceID: 'RFQSlice',
  selectCanInit: rfqSelectors.selectCanInitMarketsField,
  selectMSSRequestParams: rfqSelectors.selectMSSRequestParams,
  buildItems: buildMarketSelectorItems,
  initMarketsField: initializeRFQMarketsField,
});

export function buildMarketSelectorItems(
  state: AppState,
  onDemandState: { mss: Map<string, Map<string, MarketSecurityStatus>> | undefined }
): MarketSelectorItem[] {
  const params = rfqSelectors.selectBuildRFQMarketSelectorItemsParams(state);
  const items = getRFQMarketSelectorItems({
    ...params,
    mssByAccountBySymbol: onDemandState.mss,
    enableMSSValidation: state.referenceData.settings.enableMSSValidation,
  });

  return items;
}
